import React from 'react';
import { FiStar, FiCheckCircle, FiExternalLink } from 'react-icons/fi';
import './Reviews.css';

const testimonials = [
  {
    name: "Customer Review",
    rating: 5,
    text: "Axis Collision did an amazing job on my car after a rear-end collision. The paint match was perfect and they worked directly with my insurance. Highly recommend!",
    source: "Carwise"
  },
  {
    name: "Customer Review",
    rating: 5,
    text: "Fast turnaround and excellent communication. They kept me updated throughout the entire repair process. My car looks brand new. The lifetime warranty gives great peace of mind.",
    source: "Carwise"
  },
  {
    name: "Customer Review",
    rating: 5,
    text: "Best body shop in Spring, TX. The staff is bilingual which was very helpful. They handled everything with my insurance company and made the whole process stress-free.",
    source: "Carwise"
  }
];

const Reviews = () => {
  return (
    <section className="reviews section">
      <div className="container">
        <div className="reviews__content">
          <h2 className="reviews__title">Trusted by Our Customers</h2>
          <div className="reviews__rating">
            <div className="rating-card">
              <div className="rating-card__stars">
                {[...Array(5)].map((_, i) => (
                  <FiStar key={i} fill="currentColor" />
                ))}
              </div>
              <div className="rating-card__number">5.0</div>
              <div className="rating-card__label">Rating</div>
            </div>
            <div className="rating-card">
              <div className="rating-card__number">9</div>
              <div className="rating-card__label">Reviews</div>
            </div>
          </div>

          <div className="reviews__testimonials">
            {testimonials.map((t, i) => (
              <div key={i} className="testimonial">
                <div className="testimonial__stars">
                  {[...Array(t.rating)].map((_, j) => (
                    <FiStar key={j} fill="currentColor" />
                  ))}
                </div>
                <p className="testimonial__text">"{t.text}"</p>
                <div className="testimonial__meta">
                  <span className="testimonial__name">{t.name}</span>
                  <span className="testimonial__source">via {t.source}</span>
                </div>
              </div>
            ))}
          </div>

          <a
            href="https://www.carwise.com/auto-body-shops/axis-collision-spring-tx-77388/628308"
            target="_blank"
            rel="noopener noreferrer"
            className="reviews__link"
          >
            Read All Reviews on Carwise
            <FiExternalLink />
          </a>
          <div className="reviews__badges">
            <div className="badge">
              <FiCheckCircle />
              <span>100% Recommend</span>
            </div>
            <div className="badge">
              <FiCheckCircle />
              <span>Lifetime Warranty</span>
            </div>
            <div className="badge">
              <FiCheckCircle />
              <span>9 Years Experience</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
